import { useCallback, useEffect, useState } from 'react';

import { replaceScriptNodes } from '../lib/clone-nodes';
import { useIsClient } from './useIsClient';

export const useCallbackRef = <T = unknown>() => {
  const [current, setCurrent] = useState<T | null>(null);
  const callback = useCallback((node: T) => {
    if (node !== null) setCurrent(node);
  }, []);

  return { callback, current };
};

export const useDangerousRawHtml = (parentNode: HTMLDivElement | null, isModal = false) => {
  const [isReady, setIsReady] = useState<boolean>(false);
  const { isClient } = useIsClient();
  useEffect(() => {
    setTimeout(() => {
      if (parentNode && (isClient || isModal)) {
        replaceScriptNodes(parentNode);
        setIsReady(true);
      }
    }, 500);
  }, [parentNode, isModal]);

  return { isReady: !isClient || isReady };
};
